import { defineStore } from 'pinia';
import { setService } from '@/api/';
import { Message } from '@arco-design/web-vue';

import i18n from '@/locales/index';

// 系统设置获取对象名称
export const useCustomObject = defineStore('customObject', {
  state: () => ({
    objectName: ''
  }),
  actions: {
    setObjectName(value) {
      this.objectName = value;
    },

    getObjectName(params) {
      this.objectName = '';
      return new Promise((resolve, reject) => {
        setService
          .getSysObjEnumList({ entityType: params.entityType })
          .then((res) => {
            if (!res.error) {
              this.objectName = res.result?.entityName;
              resolve(res);
            }
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('获取数据失败'));
            reject(err);
          });
      });
    }
  }
});

export default useCustomObject;
